// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Roboto Condensed', 'Roboto Condensed Fallback'"},"className":"__className_b01152"};